/**
 * CodeEditor Component - Monaco Editor wrapper
 */
import React, { useState } from 'react';
import Editor from '@monaco-editor/react';
import './CodeEditor.css';

function CodeEditor({ value, onChange, language = 'javascript', readOnly = false, height = '400px' }) {
  const [isReady, setIsReady] = useState(false);

  const handleMount = (editor, monaco) => {
    setIsReady(true);

    // Custom theme matching AlgoSolve design
    monaco.editor.defineTheme('algosolve-dark', {
      base: 'vs-dark',
      inherit: true,
      rules: [
        { token: 'comment', foreground: '4b5563', fontStyle: 'italic' },
        { token: 'keyword', foreground: '818cf8' },
        { token: 'string', foreground: '34d399' },
        { token: 'number', foreground: 'fb923c' },
        { token: 'identifier', foreground: 'e2e8f0' },
      ],
      colors: {
        'editor.background': '#0d1117',
        'editor.foreground': '#e6edf3',
        'editorLineNumber.foreground': '#374151',
        'editorLineNumber.activeForeground': '#6366f1',
        'editor.selectionBackground': '#6366f133',
        'editor.lineHighlightBackground': '#161b22',
        'editorCursor.foreground': '#818cf8',
        'editor.findMatchBackground': '#6366f155',
      }
    });
    monaco.editor.setTheme('algosolve-dark');
  };

  return (
    <div className="code-editor-wrapper">
      {!isReady && (
        <div className="editor-loading">
          <div className="spinner" />
        </div>
      )}
      <Editor
        height={height}
        language={language}
        value={value}
        onChange={onChange}
        onMount={handleMount}
        options={{
          readOnly,
          minimap: { enabled: false },
          fontSize: 13,
          lineHeight: 22,
          fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
          fontLigatures: true,
          scrollBeyondLastLine: false,
          wordWrap: 'on',
          tabSize: 2,
          renderLineHighlight: 'line',
          cursorBlinking: 'smooth',
          smoothScrolling: true,
          padding: { top: 16, bottom: 16 },
        }}
      />
    </div>
  );
}

export default CodeEditor;
